import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { MaskedLines, Reveal } from "./Reveal";
import { AviahWatermark } from "./AviahMark";

// Shared inner-page hero: breadcrumb, eyebrow, masked title lines, copy.
const PageHero = ({ eyebrow, lines, copy, breadcrumb = [], testid = "page-hero" }) => (
  <section className="relative overflow-hidden border-b border-[#171717]/10 bg-[#F4F0E8]" data-testid={testid}>
    <AviahWatermark className="absolute -right-20 top-1/2 h-96 w-96 -translate-y-1/2 text-[#171717] opacity-[0.04]" />
    <div className="relative mx-auto max-w-7xl px-5 pb-16 pt-32 sm:px-8 sm:pb-24 sm:pt-44">
      {breadcrumb.length > 0 && (
        <nav aria-label="Breadcrumb" className="mb-8">
          <ol className="flex flex-wrap items-center gap-2 text-[0.65rem] uppercase tracking-[0.18em] text-[#171717]/45">
            {breadcrumb.map((b, i) => (
              <li key={i} className="flex items-center gap-2">
                {i > 0 && <ChevronRight className="h-3 w-3 opacity-50" />}
                {b.to ? (
                  <Link to={b.to} className="transition-colors hover:text-[#8a6f3e]">
                    {b.label}
                  </Link>
                ) : (
                  <span className="text-[#8a6f3e]">{b.label}</span>
                )}
              </li>
            ))}
          </ol>
        </nav>
      )}
      {eyebrow && (
        <Reveal>
          <p className="eyebrow text-[#8a6f3e]">{eyebrow}</p>
        </Reveal>
      )}
      <MaskedLines
        lines={lines}
        delay={0.1}
        className="mt-6 max-w-4xl text-4xl font-light leading-[1.08] tracking-tight text-[#171717] sm:text-5xl lg:text-6xl"
      />
      {copy && (
        <Reveal delay={0.45}>
          <p className="mt-8 max-w-xl text-sm leading-relaxed text-[#171717]/70 sm:text-base">{copy}</p>
        </Reveal>
      )}
    </div>
  </section>
);

export default PageHero;
